import {
  Typography as MUITypography,
  TypographyProps as MUITypographyProps,
} from '@mui/material';
import type { Theme } from '@mui/material/styles';
import {
  unstable_extendSxProp as extendSxProp,
  type SystemProps,
} from '@mui/system';

// MUI v9 removed system style props (fontWeight, textAlign, mb, etc.) and the
// `paragraph` prop from Typography. We keep the old ergonomics by accepting
// system props and folding them into `sx`, and re-implementing `paragraph`.
export type TypographyProps = MUITypographyProps &
  SystemProps<Theme> & {
    paragraph?: boolean;
  };

export function Typography(props: TypographyProps) {
  const { paragraph, ...rest } = props;
  const extended = extendSxProp(rest);
  if (paragraph) {
    return (
      <MUITypography
        component="p"
        {...extended}
        sx={[
          { marginBottom: '16px' },
          ...(Array.isArray(extended.sx) ? extended.sx : [extended.sx]),
        ]}
      />
    );
  }
  return <MUITypography {...extended} />;
}
